import { searchResultCourseCard } from "./components/search-result_course-card";
import { searchResultOtherCard } from "./components/search-result_other-card";

export const appSearchOverlay = {
    create: function () {
        var that = this;
        that.bindEvents();
    },
    bindEvents: function () {
        var that = this;
        $(document).on("click", ".js-so-open", function (e) {
            e.preventDefault();
            $(this).attr("aria-expanded", "true");
            $(".js-search-overlay").attr("aria-hidden", "false");
            $(".js-search-overlay").find("[data-ti]").removeAttr("tabindex");
            $("body").addClass("no-scroll");
            $(".js-search-overlay").find(".js-so-term").focus();
        });
        $(document).on("click", ".js-so-close", function (e) {
            e.preventDefault();
            $(".js-so-open").attr("aria-expanded", "false");
            $(".js-search-overlay").attr("aria-hidden", "true");
            $(".js-search-overlay").find("[data-ti]").attr("tabindex", "-1");
            $(".js-search-overlay").find(".js-search-results").html("");
            $(".js-search-overlay").find(".js-so-suggs").html("");
            $(".js-search-overlay").find(".js-so-term").val("");
            $("body").removeClass("no-scroll");
            $(".js-so-open").focus();
        });
        $(document).on("click", ".js-soloc-dd", function (e) {
            e.preventDefault();
            var isOpen = $(this).attr("aria-expanded") == "true" ? true : false;
            if (!isOpen) {
                that.openLocDD();
            } else {
                that.closeLocDD();
            }
        });
        $(document).on("click", ".js-soloc-option", function (e) {
            e.preventDefault();
            var mail = $(this).attr("data-email"),
                phone = $(this).attr("data-phone"),
                address = $(this).attr("data-address"),
                selected = $(this).attr("data-selected");
            that.showHeaderContact(mail, phone, address, selected);
        });
        $(document).on("click", function (e) {
            var isLocDD = $('[data-type="location-dd"]').has(e.target).length
                ? true
                : false;
            if (!isLocDD) {
                var locOpen =
                    $(".js-soloc-dd").attr("aria-expanded") == "false"
                        ? false
                        : true;
                if (locOpen) {
                    that.closeLocDD();
                }
            }
        });
        $(document).on("focusin", ".js-so-loc", function () {
            $(".js-search-overlay").find(".js-so-suggs").html("");
        });
        $(document).on("focusin", ".js-so-close", function () {
            $(".js-search-overlay").find(".js-so-suggs").html("");
        });
        $(document).on("focusin", ".so-res-details-button", function () {
            $(".js-search-overlay").find(".js-so-suggs").html("");
        });
        $(document).on("click", ".js-sug-item", function (e) {
            e.preventDefault();
            var sTerm = $(this).find(".sug").text();
            //console.log('get results: ', sTerm);
            that.getResults(sTerm);
        });
        $(document).on("click", ".js-nosugg-item", function (e) {
            e.preventDefault();
        });
        $(document).on("input", ".js-so-term", function () {
            var sTerm = $(this).val();
            that.querySuggestions(sTerm);
            // console.log("sTerm", sTerm);
        });
        /*
            $(document).on('focusout', '.js-so-term-wrapper', function(){
                $('.js-search-overlay').find('.js-so-suggs').html('');
            });
            */
        $(document).on("keydown", function (e) {
            if (e.which == 9) {
                //console.log('Tab');
                var hasResults =
                    $(".so-res-details-button").length < 1 ? false : true;
                if (e.shiftKey) {
                    // Search Overlay Close Button
                    var soCloseButton = $(".js-so-close").is(":focus");
                    if (soCloseButton) {
                        e.preventDefault();
                        if (hasResults) {
                            $(".so-res-details-button:last")
                                .eq(0)
                                .trigger("focus");
                        } else {
                            $(".js-soloc-dd").eq(0).trigger("focus");
                        }
                    }
                } else {
                    if (hasResults) {
                        // Last Search Overlay Link
                        var lastSearchOverlayLink = $(
                            ".so-res-details-button:last"
                        ).is(":focus");
                        // if (lastSearchOverlayLink) {
                        //     e.preventDefault();
                        //     $(".js-so-close").eq(0).trigger("focus");
                        // }
                        // // First Location Link
                        // var firstLocLink = $(".js-soloc-option:first").is(
                        //     ":focus"
                        // );
                        // if (firstLocLink) {
                        //     e.preventDefault();
                        //     $(".js-soloc-dd").eq(0).trigger("focus");
                        //     that.closeLocDD();
						// 	console.log('firstLocLink :>> ', firstLocLink);
                        // }
                    } else {
                        // Last Search Overlay Field
                        var lastSearchOverlayField =
                            $(".js-soloc-dd").is(":focus");
                        // if (lastSearchOverlayField) {
                        //     e.preventDefault();
                        //     $(".js-so-close").eq(0).trigger("focus");
                        // }
                        //Last Location Link
                        var lastLocLink = $(".js-soloc-option:last").is(
                            ":focus"
                        );
                        if (lastLocLink) {
                            e.preventDefault();
                            $(".js-soloc-dd").eq(0).trigger("focus");
                            that.closeLocDD();
                        }
                    }
                }
            } else if (e.which == 27) {
                //console.log('Escape');
                e.preventDefault();
                $(".js-so-open").attr("aria-expanded", "false");
                $(".js-search-overlay").attr("aria-hidden", "true");
                $(".js-search-overlay")
                    .find("[data-ti]")
                    .attr("tabindex", "-1");
                $(".js-search-overlay").find(".js-search-results").html("");
                $(".js-search-overlay").find(".js-so-suggs").html("");
                $(".js-search-overlay").find(".js-so-term").val("");
                $("body").removeClass("no-scroll");
                $(".js-so-open").focus();
            }
        });
    },
    openLocDD: function () {
        var that = this;
        $(".js-soloc-dd").attr("aria-expanded", "true");
        $('[data-type="location-dd"]')
            .find(".js-soloc-dd-menu")
            .attr("aria-hidden", "false");
        $('[data-type="location-dd"]')
            .find(".js-soloc-dd-menu .js-soloc-option")
            .removeAttr("tabindex");
        $(".js-soloc-option").eq(0).trigger("focus");
    },
    closeLocDD: function () {
        var that = this;
        $(".js-soloc-dd").attr("aria-expanded", "false");
        $('[data-type="location-dd"]')
            .find(".js-soloc-dd-menu")
            .attr("aria-hidden", "true");
        $('[data-type="location-dd"]')
            .find(".js-soloc-dd-menu .js-soloc-option")
            .attr("tabindex", "-1");
        setTimeout(function () {
            $(".js-soloc-dd").trigger("focus");
        }, 50);
    },
    showHeaderContact: function (mail, phone, address, selected) {
        var that = this,
            contactInfo =
                '<div class="header-contact-info"><a href="mailto:' +
                mail +
                '" class="header-contact-mail"><svg aria-label="mail"><use xlink:href="/images/frontend/main-icons.svg#mail-icon"></use></svg><span>' +
                mail +
                '<span></a><a href="' +
                phone +
                '"class="header-contact-phone"><svg aria-label="phone"><use xlink:href="/images/frontend/main-icons.svg#phone-icon"></use></svg><span>' +
                phone +
                '<span></a><div class="header-contact-address"><span>' +
                address +
                "<span></div></div>";
        $(".js-header-contact").html($(contactInfo));
        $(".js-soloc-dd span").html(selected);
        $(".js-location-dd span").html(selected);
        that.closeLocDD();
    },
    querySuggestions: function (sTerm) {
		const prefetchedLocale = window.jslocale?.prefetched || {};
        const { minlength, noresults } = prefetchedLocale;
        var that = this,
            soMoreChars =
                `<ul class="so-res-suggs"><li><a class="js-nosugg-item" href="#"><span class="sug">${minlength}</span></a></li></ul>`;

        if (sTerm.length < 3) {
            $(".js-search-overlay").find(".js-so-suggs").html($(soMoreChars));
        } else {
            that.getSuggs(sTerm);
        }
        /*
            $('.js-search-overlay').find('.js-so-suggs').html('<ul class="so-res-suggs"><li><a class="js-sug-item" href="#"><span class="sug">Rücken</span><span class="num">78 Kurse</span></a></li><li><a class="js-sug-item" href="#"><span class="sug">Rückenfit</span><span class="num">12 Kurse</span></a></li><li><a class="js-sug-item" href="#"><span class="sug">Rückengymnastik</span><span class="num">7 Kurse</span></a></li><li><a class="js-sug-item" href="#"><span class="sug">Rückentraining</span><span class="num">3 Kurse</span></a></li>');
            */
    },
    buildResults: function (data) {
        const prefetchedLocale = window.jslocale?.prefetched || {};

        const {
            found_courses,
            found_projects,
            found_blogs,
            found_pages,
            showall_kurse,
            showall_pages,
            showall_projekte,
            showall_blogs,
        } = prefetchedLocale;
          
        if (data.length > 0) {
            let soResults = "";

            $.each(data, function (index, group) {
                let groupTitleLabel, showAllButtonLabel;

                if (group.groupValue == "kurse") {
                    groupTitleLabel = found_courses;
                    showAllButtonLabel = showall_kurse;
                } else if (group.groupValue == "projekte") {
                    groupTitleLabel = found_projects;
                    showAllButtonLabel = showall_projekte;
                } else if (group.groupValue == "blog") {
                    groupTitleLabel = found_blogs;
                    showAllButtonLabel = showall_blogs;
                } else if (group.groupValue == "pages") {
                    groupTitleLabel = found_pages;
                    showAllButtonLabel = showall_pages;
                }

                const groupTitle = `<div class="so-res-title" role="status">${groupTitleLabel}: ${group.doclist.numFound}</div>`;

                const showAllButton = `
                <div class="so-res-see-all">
                    <button type="submit" class="so-res-details-button" aria-label="${showAllButtonLabel}">${showAllButtonLabel}</button>
                </div>`;

                soResults += groupTitle;

                if (group.groupValue == "kurse") {
                    $.each(group.doclist.docs, function (index, course) {
                        soResults += searchResultCourseCard(course);
                    });
                } else {
                    $.each(group.doclist.docs, function (index, other) {
                        soResults += searchResultOtherCard(other);
                    });
                }
                // soResults += showAllButton;
            });

            $(".js-search-overlay")
                .find(".js-search-results")
                .html($(soResults));
        } else {
            $(".js-search-overlay").find(".js-search-results").html("");
        }
    },

    getResults: function (sTerm) {
        const prefetchedLocale = window.jslocale?.prefetched || {};
        const { noresults } = prefetchedLocale;
        var that = this,
            soNoSugg =
                `<ul class="so-res-suggs"><li><a class="js-nosugg-item" href="#"><span class="sug">${noresults}</span></a></li></ul>`,
            eID = $("#standort_id").val() ? $("#standort_id").val() : null,
            locale = $("html").attr("lang") ?? "de";
        if (sTerm.length > 0) {
            $.ajax({
                url: soGetSuggs,
                dataType: "json",
                type: "POST",
                data: {
                    searchtext: sTerm,
                    eID: eID,
                    locale: locale,
                },
            })
                .done((jsonData) => {
                    //console.log('get response: ', jsonData);
                    if (
                        jsonData.response.prefetchedResults.grouped
                            .sem_record_type.groups.length > 0
                    ) {
                        var suggGroups =
                            jsonData.response.prefetchedResults.grouped
                                .sem_record_type.groups;
                        // console.log(suggGroups);
                        that.buildResults(suggGroups);
                    } else {
						console.log('NoSuggestions');
                        $(".js-search-overlay")
                            .find(".js-so-suggs")
                            .html($(soNoSugg));
                        $(".js-search-overlay")
                            .find(".js-search-results")
                            .html("");
                    }
                })
                .fail((jsonData) => {
                    $(".js-search-overlay")
                        .find(".js-so-suggs")
                        .html($(soNoSugg));
                    $(".js-search-overlay").find(".js-search-results").html("");
                });
            // load JSON data
            /*
                fetch(soGetSuggs + sTerm)
                .then(response => response.json())
                .then(function(jsonData){
                    //console.log('get response: ', jsonData);
                    if(jsonData.response.prefetchedResults.grouped.sem_record_type.groups.length > 0){
                        var suggGroups = jsonData.response.prefetchedResults.grouped.sem_record_type.groups;
                        that.buildResults(suggGroups);
                    } else {
                        $('.js-search-overlay').find('.js-so-suggs').html($(soNoSugg));
                    }
                });
                */
        }
    },
    getSuggs: function (sTerm) {
		const prefetchedLocale = window.jslocale?.prefetched || {};
        const { noresults } = prefetchedLocale;
        var that = this,
            suggGroups,
            suggItems = "",
            soSuggStart = '<ul class="so-res-suggs tags">',
            soSuggItemStart =
                '<li><a class="js-sug-item" href="#"><span class="sug">',
            soSuggItemMid = '</span><span class="num">',
            soSuggItemEnd = "</span></a>",
            soSuggEnd = "</ul>",
            soSuggResults = "",
            soNoSugg =
                `<ul class="so-res-suggs"><li><a class="js-nosugg-item" href="#"><span class="sug">${noresults}</span></a></li></ul>`,
            eID = $("#standort_id").val() ? $("#standort_id").val() : null,
            locale = $("html").attr("lang") ?? "test";
        $.ajax({
            url: soGetSuggs,
            dataType: "json",
            type: "POST",
            data: {
                searchtext: sTerm,
                eID: eID,
                locale: locale,
            },
        })
            .done((jsonData) => {
                // console.log("response: ", jsonData);
                if (jsonData.response.autocomplete.suggestions.length > 0) {
                    var suggestions =
                        jsonData.response.autocomplete.suggestions;
                    suggItems = "";
                    suggGroups =
                        jsonData.response.prefetchedResults.grouped
                            .sem_record_type.groups;
                    //console.log('suggestions: ', suggestions);
                    //console.log('groups: ', suggGroups);
                    $.each(suggestions, function (index, sugg) {
                        // console.log("sugg :>> ", sugg);
                        const {
                            suggestion,
                            hits,
                            sem_action: { sem_url },
                        } = sugg;
                        var suggItem = `<li><a class="js-sug-item" href="/s${sem_url}"><span class="sug">${suggestion}</span><span class="num">${hits}</span></a></li>`;
                        suggItems = suggItems + suggItem;
                    });
                    soSuggResults = soSuggStart + suggItems + soSuggEnd;
                    $(".js-search-overlay")
                        .find(".js-so-suggs")
                        .html($(soSuggResults));
                    that.buildResults(suggGroups);
                } else {
                    $(".js-search-overlay")
                        .find(".js-so-suggs")
                        .html($(soNoSugg));
					$(".js-search-overlay")
						.find(".js-search-results")
						.html("");
                }
            })
            .fail((jsonData) => {
                $(".js-search-overlay").find(".js-so-suggs").html($(soNoSugg));
            });
        // load JSON data
        /*
            fetch(soGetSuggs + sTerm)
                .then(response => response.json())
                .then(function(jsonData){
                    //console.log('response: ', jsonData);
                    if(jsonData.response.autocomplete.suggestions.length > 0){
                        var suggestions = jsonData.response.autocomplete.suggestions
                            suggItems = "",
                            suggGroups = jsonData.response.prefetchedResults.grouped.sem_record_type.groups;
                            //console.log('suggestions: ', suggestions);
                            //console.log('groups: ', suggGroups);
                        $.each(suggestions, function(index,sugg){
                                var suggItem = soSuggItemStart + sugg.suggestion + soSuggItemMid + sugg.hits + soSuggItemEnd;
                                suggItems = suggItems + suggItem;
                        });
                        soSuggResults = soSuggStart + suggItems + soSuggEnd;
                        $('.js-search-overlay').find('.js-so-suggs').html($(soSuggResults));
                        that.buildResults(suggGroups);
                    } else {
                        $('.js-search-overlay').find('.js-so-suggs').html($(soNoSugg));
                    }
                });
            */
    },
};
export const soGetSuggs = "/ajax/getSuggestResults";
//export const soGetSuggs = 'http://localhost:8989/sl/suggest?q=';
//export const soGetSuggs = 'http://cors-free.local/sl/suggest?q=';
